import React, { useEffect, useState } from 'react'
import { CATEGORIES } from '../Tags'
import { Category } from '../components/Category'
import { Button } from '../components/Button'
import styles from '../container/Home.module.css'
import categoryStyles from './Category.module.css'
import { HiOutlineMail, HiOutlineGlobe, HiOutlinePhone } from 'react-icons/hi'

export const ShopTemplate = ({ shop }) => {
  const [lng, setLng] = useState(13.086341)
  const [lat, setLat] = useState(47.72412)

  const filtered = CATEGORIES.filter(
    (category) => shop.categories.includes(category.id) === true,
  )

  useEffect(() => {
    getLocation()
  }, [])

  const getLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        setLat(position.coords.latitude)
        setLng(position.coords.longitude)
      })
    }
  }

  return (
    <>

      <div className={styles.header}>
        <h2>{shop.shopname}</h2>
        <p>
          {shop.street}
          <br />
          {shop.postcode} {shop.place}
        </p>
      </div>
      <h3>Kontakt</h3>
      <div className={styles.contact}>
        <HiOutlineMail />
        <a href={`mailto:${shop.email}`}>{shop.email}</a>
        {shop.link === '' ? (
          ''
        ) : (
          <>
            <HiOutlineGlobe />
            <a href={shop.link} target="_blank" rel="noreferrer">
              {shop.link}
            </a>
          </>
        )}
        {shop.phone === '' ? (
          ''
        ) : (
          <>
            <HiOutlinePhone />
            <span>{shop.phone}</span>
          </>
        )}
      </div>
      <h3>Informationen</h3>
      <p>
        Öffnungszeiten:
        <br />
        {shop.openingHours}
      </p>
      <div className={categoryStyles.category_container}>
        {filtered.map((category) => {
          return (
            <Category className={styles.categories}
              key={category.id}
              category={category}
              isSelected={true}
              onCategoryClick={() => { }}
              variant="Small"
            />
          )
        })}
      </div>
      <div>
        <Button
          onClick={() => {
            let destination = `${shop.street}+${shop.postcode}+${shop.place}`
            window.open(
              `https://www.google.com/maps/dir/?api=1&origin=${lat},${lng}&destination=${destination}&travelmode=car`,
              '_blank',
            )
          }}
        >
          Route berechnen
        </Button>
      </div>
    </>
  )
}
